import { render, staticRenderFns } from "./uf_is_reg_fond_help.vue?vue&type=template&id=46dadb03&scoped=true"
import script from "./uf_is_reg_fond_help.vue?vue&type=script&lang=js"
export * from "./uf_is_reg_fond_help.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dadb03",
  null
  
)

export default component.exports